export default __webpack_public_path__ + "static/popup-pic-006-a5c1c13ea042dbbaa716e8f483f0a395.jpg";